var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminEditDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22v5h5l14.746-14.747-5-5zm3.893 2.333H5.667v-1.226l12.08-12.08 1.227 1.227zm19.72-17.826l-3.12-3.12a1.336 1.336 0 0 0-1.88 0l-2.44 2.44 5 5 2.44-2.44a1.328 1.328 0 0 0 0-1.88z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminEditDocument);
export default __webpack_public_path__ + "static/media/admin-edit-document.a503b7c2f13afe33af09a7725ed12eea.svg";
export { ForwardRef as ReactComponent };